export default __webpack_public_path__ + "static/media/seed.c53422b8.png";